export const partners = [
  {
    name: "Shippo",
    description:
      "Mobile360 has partnered with Shippo to provide you fast, discounted shipping. Your Mobile360 orders automatically sync with Shippo, allowing you to print discounted shipping labels, track shipments, notify customers, and streamline returns. Sign up to get started!.",
    brandColor: "#7fad34",
    logo: "https://mobile360-assets.s3.us-east-2.amazonaws.com/shippo_logo.svg",
    link: "https://goshippo.com",
  },
  {
    name: "Stripe",
    description:
      "Mobile360 has partnered with Stripe to provide you with the best in class payment processing. Accept credit cards, Apple Pay, and Google Pay via your Mobile360 website and mobile app. Use Stripe’s powerful analytics to track your business earnings, fraud detection to prevent unwanted customers, and get tax statements at the end of each year. Your app will be PCI compliant, guaranteed your customers the safest experience.",
    brandColor: "#635CFF",
    logo: "https://mobile360-assets.s3.us-east-2.amazonaws.com/stripe_logo.svg",
    link: "https://stripe.com",
  },
  {
    name: "Insurance Canopy",
    description:
      "Mobile360 was built to provide small businesses a fighting chance in the realm of technology. Insurance Canopy aims to do the same in the insurance space. They provide comprehensive, but affordable insurance for various types of small businesses. Mobile360 members get exclusive discounts with Insurance Canopy, keeping your business safe from unplanned incidents.  ",
    brandColor: "#256A6A",
    logo: "https://mobile360-assets.s3.us-east-2.amazonaws.com/insurance_canopy.svg",
    link: "https://insurancecanopy.com/policy/buy/ai/MTgyNQ==",
  },
  {
    name: "Zest Business Consulting",
    description:
      "Mobile360 has partnered with Zest Business Consulting to provide you coaching and resources you need to make your business succeed! Exclusive offer for Mobile360 customers - 1 FREE 30 minute business strategy session and a once a month live Business Powershot Webinar, filled with actionable business development insights and tips to affordably grow your business ($299 value). Must be a Mobile360 customer. ",
    brandColor: "#829E22",
    logo: "https://mobile360-assets.s3.us-east-2.amazonaws.com/zest_logo.jpeg",
    link: "https://www.ZestBusinessConsulting.com",
  },
];

export const tiers = [
  {
    title: "Monthly",
    subheader: "Month to Month\u000ANo Commitment",
    price: "99.99",
    description: [
      "iOS & Android app",
      "Hosted Website",
      "All Features Included",
      "Marketplace highlights",
      "Expedited Support",
      "Community Resources",
    ],
    stripePriceId:
      process.env.NODE_ENV === "prod"
        ? "plan_H0bXxwYljA9WpL"
        : "plan_H0X3unk7tpiCq9",
  },
  {
    title: "Monthly",
    subheader: "w/1 Year Commitment\u000ASave 50%",
    price: "49.99",
    description: [
      "iOS & Android app",
      "Hosted Website",
      "All Features Included",
      "Marketplace Highlights",
      "Expedited Support",
      "Community Resources",
    ],
    stripePriceId:
      process.env.NODE_ENV === "prod"
        ? "plan_GAkUyX4Fsi8klG"
        : "price_1JDY3mE93r4moyz0UgdWg5tx",
  },
  {
    title: "Annual",
    subheader: "Most Popular\u000ASave 70%",
    price: "29.99",
    description: [
      "iOS & Android app",
      "Hosted Website",
      "All Features Included",
      "Marketplace Highlights",
      "Expedited Support",
      "Community Resources",
    ],
    stripePriceId:
      process.env.NODE_ENV === "prod"
        ? "price_1J8sHJE93r4moyz0xIQpUS0O"
        : "price_1JDY8xE93r4moyz0btfUP3Xw",
  },
  {
    title: "Premium",
    subheader: "(For high transaction volumes)",
    price: "299.99",
    description: [
      "iOS & Android app",
      "Hosted Website",
      "All Features Included",
      "Marketplace Highlights",
      "Expedited Support",
      "Community Resources",
      "Customer Service Agent",
      "Custom Feature Requests",
      "Business Development Planning",
    ],
    stripePriceId:
      process.env.NODE_ENV === "prod"
        ? "price_1JDYBSE93r4moyz0OXGFNJ6L"
        : "price_1JDYB9E93r4moyz0kZ7FEUrl",
  },
];

export const redemptionTypeOptions = [
  {
    value: 0,
    label: "None",
    description:
      "To redeem a deal, simply request the customer to click the redeem button on their app.",
  },
  {
    value: 1,
    label: "Password Entry",
    description:
      "When a customer redeems a deal, your staff member will type in the deal password that you specify below.",
  },
  {
    value: 2,
    label: "Customer Scans Your QR Code",
    description:
      "When redeeming a deal, a customer will scan your unique QR code with their camera, which can be downloaded and printed below.",
  },
  {
    value: 3,
    label: "You Scan Customer’s QR Code",
    description:
      "When the customer redeems a deal, a QR code will pop up on their phone. Using the admin panel on your Mobile360 app, scan the customer’s QR code.",
  },
];

export const storeRedemptionTypeOptions = [
  {
    value: 0,
    label: "None",
    description:
      "To redeem a store item, simply request the customer to click the redeem button on their app.",
  },
  {
    value: 1,
    label: "Password Entry",
    description:
      "When a customer redeems a store item, your staff member will type in the store item password that you specify below.",
  },
  {
    value: 2,
    label: "Customer Scans Your QR Code",
    description:
      "When redeeming a store item, a customer will scan your unique QR code with their camera, which can be downloaded and printed below.",
  },
  {
    value: 3,
    label: "You Scan Customer’s QR Code",
    description:
      "When the customer redeems a store item, a QR code will pop up on their phone. Using the admin panel on your Mobile360 app, scan the customer’s QR code.",
  },
];

export const redemptionTypeOptions2 = [
  {
    value: 1,
    label: "Password Entry",
    description:
      "When a customer redeems a deal, your staff member will type in the deal password that you specify below.",
  },
  {
    value: 2,
    label: "Customer Scans Your QR Code",
    description:
      "When redeeming a deal, a customer will scan your unique QR code with their camera, which can be downloaded and printed below.",
  },
  {
    value: 3,
    label: "You Scan Customer’s QR Code",
    description:
      "When the customer redeems a deal, a QR code will pop up on their phone. Using the admin panel on your Mobile360 app, scan the customer’s QR code.",
  },
];
export const punchcardRedemptionTypeOptions = [
  {
    value: 1,
    label: "Password Entry",
    description:
      "When a customer redeems a punchcard, your staff member will type in the punchcard password that you specify below.",
  },
  {
    value: 2,
    label: "Customer Scans Your QR Code",
    description:
      "When redeeming a punchcard, a customer will scan your unique QR code with their camera, which can be downloaded and printed below.",
  },
  {
    value: 3,
    label: "You Scan Customer’s QR Code",
    description:
      "When the customer redeems a punchcard, a QR code will pop up on their phone. Using the admin panel on your Mobile360 app, scan the customer’s QR code.",
  },
];

export const templatePermissionMap = {
  titleText: 2,
  imageTitleText: 2,
  deals: 2,
  store: 2,
  rewards: 2,
  pictureCatalog: 2,
  website: 2,
  punchCard: 2,
};

export const permissionOptions = [
  {
    value: 0,
    label: "Super User",
  },
  {
    value: 1,
    label: "View Analytics",
  },
  {
    value: 2,
    label: "Manage App Features",
  },
  {
    value: 3,
    label: "Manage Notifications",
  },
  {
    value: 4,
    label: "Redeem Customer QR Codes",
  },
  // {
  //   value: 5,
  //   label: 'PUSH NOTIFICATIONS'
  // },
  // {
  //   value: 6,
  //   label: 'REWARDS'
  // },
  // {
  //   value: 7,
  //   label: 'REWARD CODE'
  // },
  // {
  //   value: 8,
  //   label: 'DELETE'
  // },
  // {
  //   value: 9,
  //   label: 'USER MANAGEMENT'
  // },
];
export const templateTypes = {
  titleText: {
    title: "Title & Text",
    description: "A simple page with two customizable text fields.",
    imageUrl:
      "https://mobile360-assets.s3.us-east-2.amazonaws.com/templatePreviews/title_text_template.png",
    examples: "Example: Monthly Special, About Us",
  },
  imageTitleText: {
    title: "Image, Title & Text",
    description: "A scrolling image set with two customizable text fields.",

    imageUrl:
      "https://mobile360-assets.s3.us-east-2.amazonaws.com/templatePreviews/image_title_text_template.png",
    examples: "Example: Secret Menu, About Us",
  },
  pictureCatalog: {
    title: "Image Gallery",
    description: "A gallery page with photos and descriptions.",
    imageUrl:
      "https://mobile360-assets.s3.us-east-2.amazonaws.com/templatePreviews/picture_catalog_template.png",
    examples: "Example: Menu, Image Gallery",
  },
  store: {
    title: "Store",
    description:
      "This page allows you to create a store for your business. Here users can buy your goods.",
    imageUrl:
      "https://mobile360-assets.s3.us-east-2.amazonaws.com/empty_phone.png",
  },
  website: {
    title: "Website",
    description: "Link any website. Add existing integrations seamlessly.",
    imageUrl:
      "https://mobile360-assets.s3.us-east-2.amazonaws.com/templatePreviews/website_template.png",
    examples: "Example: Yelp, Grubhub, OpenTable",
  },
  deals: {
    title: "Deals",
    description:
      "Create deals and coupons for your business to incentivize customers to return.",
    imageUrl:
      "https://mobile360-assets.s3.us-east-2.amazonaws.com/templatePreviews/deals_template.png",
    examples: "Example: About Us",
  },
  rewards: {
    title: "Rewards",
    description: "Create a customized rewards system.",
    imageUrl:
      "https://mobile360-assets.s3.us-east-2.amazonaws.com/templatePreviews/rewards_template.png",
    examples: "Points per purchase, customer cash credit, redeem reward items.",
  },
  punchCard: {
    title: "Punch Card",
    description: "Old school punch cards, digitized.",
    imageUrl:
      "https://mobile360-assets.s3.us-east-2.amazonaws.com/templatePreviews/punchcard_template.png",
    examples: "Example: Buy 5 coffees, get one free.",
  },
  // aboutUs: {
  //   title: 'About Us',
  //   description: ''
  // },
};

// export const videoSections = [
//   {
//     sectionName: "First Section",
//     videos: [
//       [
//         {
//           videoName: "video1",
//           youtubeLink: "https://www.youtube.com/embed/1uWT_L58MGc"
//         },
//         {
//           videoName: "video2",
//           youtubeLink: "https://www.youtube.com/embed/1uWT_L58MGc"
//         },
//         {
//           videoName: "video3",
//           youtubeLink: "https://www.youtube.com/embed/1uWT_L58MGc"
//         }
//       ],
//       [
//         {
//           videoName: "video4",
//           youtubeLink: "https://www.youtube.com/embed/1uWT_L58MGc"
//         },
//         {
//           videoName: "video5",
//           youtubeLink: "https://www.youtube.com/embed/1uWT_L58MGc"
//         },
//         {
//           videoName: "video6",
//           youtubeLink: "https://www.youtube.com/embed/1uWT_L58MGc"
//         }
//       ]
//     ]
//   },
//   {
//     sectionName: "Second Section",
//     videos: [
//       [
//         {
//           videoName: "video7",
//           youtubeLink: "https://www.youtube.com/embed/1uWT_L58MGc"
//         },
//         {
//           videoName: "video8",
//           youtubeLink: "https://www.youtube.com/embed/1uWT_L58MGc"
//         },
//         {
//           videoName: "video9",
//           youtubeLink: "https://www.youtube.com/embed/1uWT_L58MGc"
//         }
//       ],
//       [
//         {
//           videoName: "video10",
//           youtubeLink: "https://www.youtube.com/embed/1uWT_L58MGc"
//         },
//         {
//           videoName: "video11",
//           youtubeLink: "https://www.youtube.com/embed/1uWT_L58MGc"
//         },
//         {
//           videoName: "video12",
//           youtubeLink: "https://www.youtube.com/embed/1uWT_L58MGc"
//         }
//       ]
//     ]
//   }
// ];

export const FAQsArray = [
  {
    question: "What is Mobile360?",
    answer:
      "Mobile360 was founded to give small businesses a fighting chance to keep up with technology that only their large competitors can afford. Businesses can create customized mobile apps using our proprietary mobile app builder in just 30 minutes - no coding required! Having a mobile app allows businesses to stay connected with the most important aspect of their business - their customers!",
  },
  {
    question: "How is Mobile360 different from other mobile app builders?",
    answer:
      "The biggest difference between Mobile360 and other mobile app builders is that once you create a customized mobile app your app gets hosted inside the Mobile360 marketplace. This allows us to focus on all the nuances of mobile app development and keep your cost extremely low. We absorb all developer and legal fees plus handle all your customer data and privacy so you’re not liable for them. The cost and maintenance of the servers that power your mobile app are managed by us ensuring a smooth experience for your customers. Your app gets launched immediately and any new features that are added to Mobile360 are instantly available on your app. No waiting to get your app and any updates approved by the app store. Additionally, by being on our marketplace your business becomes discoverable to all the other customers on Mobile360. This is a free way to market your business to new customers as all of your mobile app activity gets advertised onto our marketplace social feed. You’re able to leverage customer insights of all marketplace customers, not just those downloading your app. Targeting specific customers already on the marketplace allows you to grow your business.From the customers perspective they are able to manage all their favorite businesses apps under one app (Mobile360) and one account. No app clutter on their phone makes it much more likely they will download your app. All of their data, privacy, and preferences are handled by one trusted entity, Mobile360.",
  },
  {
    question: "What is the benefit of having a mobile app for my business?",
    answer:
      "Having a mobile app for your business can be an incredibly effective customer engagement strategy. Creating a personalized digital connection with customers can increase business growth and revenue significantly. Third party platforms take control away from the businesses giving them minimal input in how they are presented or how they interact with their potential customers, which is the most important part. Mobile360 puts that control back into the hands of the business owner. With a mobile app you have an entirely new marketing tool, where you control the customer’s experience and your digital relationship with them. Use some of our special features such as push notifications and exclusive offers to stay top of mind keeping your customers interested and coming back more often. Actively reach out to them rather than passively waiting for them to find you. The average person spends about 4 hours on their phone every day - why not be part of that screen time? Large corporations such as Starbucks and Chipotle have proven the worth of having a mobile app for business. Convert average customers to loyal customers, and convert loyal customers to extremely loyal customers.",
  },
  {
    question: "What is your pricing?",
    answer:
      "We have many different plans based on your business' needs. To view all of our different pricing plans visit https://www.mobile360.io/pricing.",
  },
  {
    question: "When will I be billed? How can I pay?",
    answer:
      "For the annual plan you will be billed upfront and then yearly on your renewal date. For the monthly plan billing will occur at the beginning of each month. We accept all major credit and debit cards.",
  },
  {
    question: "How can a customer download my app?",
    answer:
      "In addition to going on the Mobile360 app and searching by your apps’ name there are two other ways your customers can easily download your app. When you build an app on the Mobile360 platform each business gets a custom QR code. Upon scanning that QR code you are directly taken to your app within Mobile360 where your customers can download. Your business is also given a unique URL that takes you to your customized landing page. Simply input the URL into the address bar of your chosen web browser and follow the instructions to download the app.",
  },
  {
    question:
      "Can I edit and make changes to my mobile app on a tablet or phone?",
    answer:
      "To experience the full power and functionality of the Mobile360 platform we recommend you update the app on a laptop or computer desktop (Google Chrome web browser is recommended). You can update the app on an iPad but for now the functionality is limited and not all features will be editable. We are currently working on implementing ways you can update the app on your phone, but this is still a work in progress.",
  },
  {
    question: "Do you offer a referral program?",
    answer:
      "Yes! Earn up to 20% of your monthly membership cost for the next 6 months for each business you refer. You can even stack referral bonuses until your membership is completely FREE. You are able to refer a max of 5 people to bring down the cost of your membership. To be eligible, you and your referral must have an active membership on Mobile360 in good standing.",
  },
  {
    question: "Can I make changes to my app once it is published?",
    answer:
      "Yes, you can make changes to the app once it’s published whenever and as often as you need to. Make sure to save the changes you made. Updates will be immediately available to those who have downloaded your app. ",
  },
  {
    question: "How can I make changes to my app?",
    answer:
      "Updating and making changes to your app is easy. This was the premise behind building Mobile360. We wanted to take out all the complexities of having a mobile app to make it simple and straightforward. Go to the Mobile360 website and login with your account info. Once you navigate to your app the first page that you are taken to is “App Editor”. This is where you can update your application settings. If you scroll down further you will see a “Current Pages” section, this is where you can update, add, and/or delete the different pages on your mobile app. Within each screen you will find a mobile emulator that you can click on that brings up an edit box you can modify each item with.",
  },
  {
    question: "Where will my app be available?",
    answer:
      "When your app is launched on the Mobile360 platform it will be available to your customers on both the Apple App Store and the Google Play Store. This does not cost extra and is already worked into your membership plan. We handle all developer accounts so you don’t have to.",
  },
  // {
  //   question: "What is the cost of building a mobile app?",
  //   answer:
  //     "The typical cost of building a mobile app is upwards of $30,000. That is a low-ball estimate and what you get is a basic mobile app. Each time you want to add a new feature or update to the latest software version, you can expect to pay another couple thousand dollars. You’ll have to manage the monthly cost and maintenance of the servers that power your mobile app. If you don’t, it could result in a poor user experience for your customers. You’ll also have to create developer accounts through Apple and Google, an additional yearly cost. Legal liability also falls on you from terms of service, to privacy, to the management of customer data. Let’s also not forget the amount of time it takes to design and develop your app before it’s launched which can take 4-6 months minimum. The development team can speed up the process but that won’t equate to quality. With Mobile360 we make having your very own mobile app extremely affordable while managing all the annoyances of mobile app development.",
  // },
  {
    question: "How do I cancel my membership?",
    answer: "To cancel your membership send an email to team@mobile360.io.",
  },
  {
    question:
      "I have not found an answer to my question here. What should I do?",
    answer:
      "You can email us at team@mobile360.io. A customer service representative will promptly do their best to answer any questions you may have.",
  },
];

export const testimonials = [
  {
    name: "The Busy Wife Catering",
    description:
      "Mobile360 has allowed me to facilitate a crucial pivot with my catering business during the midst of the Coronavirus Pandemic.  I have never experienced better customer service anywhere.  Streamlining through the app has given me more time to focus on my passion.",
    logo: "https://res.cloudinary.com/dtv3rinyx/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,b_rgb:262c35/v1586361513/Mobile360/953_app/v1v7k4urlk0alkp3ufnt.jpg",
  },
  {
    name: "Masala Fusion",
    description:
      "Never could I imagine having a mobile app for my business. Mobile360 made it easy and affordable and has completely changed the way my business runs. Now, my business is right at my customer’s fingertips.",
    logo: "https://res.cloudinary.com/dtv3rinyx/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,b_rgb:262c35/v1589484706/Mobile360/1204_app/nrypnufmytgvmzv4unss.png",
  },
  {
    name: "Salsa Picante",
    description:
      "Community based, Favorites, Simplicity are just a few words that describe Mobile360.  Our mobile app online ordering has saved us hundreds of dollars from third party services, just in our first two weeks. Highly recommended!",
    logo: "https://res.cloudinary.com/dtv3rinyx/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,b_rgb:262c35/v1592963173/Mobile360/1502_app/xo5rvyft3c7rztolxiod.png",
  },
  {
    name: "Chef Tony's Seafood Restaurant",
    description:
      "The ability to actively connect with my customers through a mobile app that I customized is incredible. It allows me to keep customers engaged and interested. As a seasoned business owner, I’ve learned marketing is a key aspect to business as it helps convert general customers to loyal ones. Mobile360 does just that. Highly recommend this to business owners that feel they don't have time.",
    logo: "https://res.cloudinary.com/dtv3rinyx/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,b_rgb:262c35/v1587079758/Mobile360/652_app/Chef_Tony_Logo_Thumbnail_buden7.jpg",
  },
  {
    name: "Yara's Bites",
    description:
      "With everyones addiction to cell phones, Mobile360 helped in expanding my target audience and increase my loyal customers. I had my app up and running in 30 minutes. This experience has been incredible!",
    logo: "https://res.cloudinary.com/dtv3rinyx/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,b_rgb:262c35/v1589566422/Mobile360/1252_app/ih4pgeywoxtdjdjw98hh.png",
  },
  {
    name: "India Foods Supermarket",
    description:
      "The Mobile360 team did an awesome work in making this app quickly available. It connects the customers with the store in simple few clicks, incredible!",
    logo: "https://res.cloudinary.com/dtv3rinyx/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,b_rgb:262c35/v1589828429/Mobile360/1103_app/wezgwogputvpnn9xgor1.jpg",
  },
  {
    name: "TKO Catering",
    description:
      "I was looking for a way to take my business to the next level, but honestly had no idea on where or how to get started. I discovered Mobile360 through another business owner, and after one conversation with TJ — I knew this platform was EXACTLY what I needed! My customer base has increased and I have a streamlined process to accept orders and payments.",
    logo: "https://res.cloudinary.com/dtv3rinyx/image/upload/q_auto,w_1000,c_fill,ar_1:1,g_auto,r_max,b_rgb:262c35/v1605640579/Mobile360/2403_app/mrfaaiufuiqpyamdnisy.jpg",
  },
];

export const videoSections = [
  {
    sectionName: "Mobile360 App Marketplace",
    videos: [
      [
        {
          videoName: "How the Mobile360 App Works",
          youtubeLink: "https://www.youtube.com/embed/rO2-uHCMfAw",
        },
        {
          videoName: "How to Make a Purchase on Mobile360",
          youtubeLink: "https://www.youtube.com/embed/lCIBxk3ls6c",
        },
      ],
    ],
  },
  {
    sectionName: "Creating Your Own App? Tutorials to get Started.",
    videos: [
      [
        {
          videoName: "Step 1: Create Your Base App",
          youtubeLink: "https://www.youtube.com/embed/A6LdTSPCtdQ",
        },
        {
          videoName: "Step 2: Tour The App Editor",
          youtubeLink: "https://www.youtube.com/embed/69eZ_ezECP0",
        },
        {
          videoName: "Step 3: Store Page Setup with Additional Options",
          youtubeLink: "https://www.youtube.com/embed/KfqTXzzw8Ow",
        },
      ],
    ],
  },
  {
    sectionName: "Adding Features to Your App",
    videos: [
      [
        {
          videoName: "Deals / Exclusive Offers",
          youtubeLink: "https://www.youtube.com/embed/mty1M14JIR4",
        },
        {
          videoName: "Sell Your Products in the In App Store",
          youtubeLink: "https://www.youtube.com/embed/iwv1dJ2a7gw",
        },
        {
          videoName: "Punch Cards",
          youtubeLink: "https://www.youtube.com/embed/P2s0g1drAi8",
        },
      ],
      [
        {
          videoName: "Customizable Rewards System",
          youtubeLink: "https://www.youtube.com/embed/sU1ScFHX748",
        },
        {
          videoName: "Redemption Type Explained",
          youtubeLink: "https://www.youtube.com/embed/tzQcYDnUhBU",
        },
      ],
    ],
  },
];

export const textBoxConstants = [
  {
    header: "Power of the Mobile360 Marketplace",
    text: "All apps created on Mobile360 get hosted in the main Mobile360 app, known as the Mobile360 marketplace. The marketplace app allows us to manage the nuances and expensive costs of having a mobile app, while you leverage all the benefits of having one.",
    imgSrc:
      "https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/mobile_marketplace.png",
    bullets: [
      "We absorb all engineering costs, developer fees, and legal fees associated with owning a mobile app on the app store.",
      "We handle customer data, privacy, and preferences, so you're not liable for them.",
      "We continuously add new features and maintain the Mobile360 app, so your app is constantly evolving.",
      "We manage the cost and maintenance of databases and servers.",
      "You can utilize the mobile360.io domain so you don't have to purchase one.",
    ],
  },
  // {
  //   header: "Built In Mobile360 Benefits",
  //   text:
  //     "By hosting your mobile app on Mobile360, your app comes with many built in benefits that are free to you.",
  //   imgSrc:
  //     "https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/mobile_prototyping.svg",
  //   bullets: [
  //     "Utilize Mobile360 provided app analytics to understand your customer base and engagement in your app.",
  //     "The Mobile360 social feed highlights your app's activity to the entire Mobile360 customer base, bringing more visiblity to your business and brand.",
  //     "Join a large community of customers that actively seek to support small businesses.",
  //   ],
  // },
  // {
  //   header: "Typical Cost of a Stand-Alone Mobile App",
  //   text:
  //     "Mobile360 manages all the annoyances of mobile app development, while making it very affordable. If you were to hire a consulting firm to build a mobile app, you could expect to pay upwards of $20,000 for a bare bones, basic mobile app. That's not where it ends.",
  //   imgSrc:
  //     "https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/discount.svg",
  //   bullets: [
  //     "Takes months of design and development to launch.",
  //     "Each time you want to add a new feature, or update to the latest software version, you can expect to add another couple thousand.",
  //     "You'll have to manage the monthly cost and maintenance of servers that power your mobile app. If you don't, it could result in a poor user experience for your customer.",
  //     "You'll need to create developer accounts through Apple and Google, an additional yearly cost.",
  //     "It's in the firms best interest to focus on speed of development, but that doesn't equate to quality.",
  //     "You'll be liable for all legal aspects of your app, from terms of service, to privacy, to managing customer data.",
  //   ],
  // },
  {
    header: "Why Have a Mobile App?",
    text: "There's a reason large corporations spend millions on mobile apps every year. Having a mobile app grows your business to the next level and separates you from the competition. Here are a few of the many benefits:",
    imgSrc:
      "https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/hooked.svg",
    bullets: [
      "Organizes and streamlines your business in one place.",
      "Builds a digital customer relationship, allowing you to continously reengage them with push notifications, offers, and exclusives.",
      "Puts you in full control of the customer experience.",
      "Adds professionalism, legitimacy, and powerful technology. Websites and emails are dated.",
      "Converts average customers to loyal customers, and convert loyal customers to extremely loyal customers",
    ],
  },
  // ,
  // {
  //   header: "A Personalized Connection to your Customer",
  //   text:
  //     "A personalized experience grows loyal customers and grows business. With your mobile app, you decide how you present your business to your customer and how you interact with them. Other platforms decide how and when you're presented to potential customers, and charge an arm and a leg for it. Time to put the power back in your hands.",
  //   bullets: ["example bullet 1", "example bullet 2"],
  // },
  // {
  //   header: "You Focus on your Business, We Focus on the Tech",
  //   text:
  //     "By hosting your app in our marketplace, you don't have to worry about any of the technical, legal, or financial nuances of having a mobile app. Plus, all the features we build immediately become available to you.",
  //   bullets: [],
  // },
  // {
  //   header: "A New Way to Market",
  //   text:
  //     "Set yourself apart from competitors with a mobile app. Legitimize and enhace your business and your brand. Your customers are on mobile, so why aren't you!",
  //   bullets: [],
  // },
  // {
  //   header: "Automated Push Notifications",
  //   text:
  //     "Emails get buried, push notifications don't. Setup automated and recurring notifications to make sure you're top of mind for your customers. Why wait for your customers to come to you when you reach out to them?",
  //   bullets: [],
  // },
  // {
  //   header: "A Whole New Revenue Stream",
  //   text:
  //     "We’ll send you a check every month! Sell your favorite products through the app to grow your business even more.",
  //   bullets: [],
  // },
  // {
  //   header: "Compete with the Big Dogs",
  //   text:
  //     "We want to empower small businesses in this world dominated by mobile devices. Companies like Starbucks have shown the many benefits of having a mobile app for your business, but it comes at extremely high cost that only large corporations can afford. Now, you can too.",
  //   bullets: [],
  // },
  // {
  //   header: "Time is Money",
  //   text:
  //     "Get your app up and running within minutes using our website's template based app builder. Then, control most of your content and experience on the go from the admin panel in your mobile app.",
  //   bullets: [],
  // },
  // {
  //   header: "Get Discovered by New Customers",
  //   text:
  //     "Turning your current customers into loyal customers is great, but getting new ones is even better. Because all apps are hosted in the Mobile360 marketplace, you will be discoverable to customers downloading other apps. Plus, the more that customers interact with your app, the more you will show up on the Mobile360 social feed, enticing new customers to visit your app.",
  //   bullets: [],
  // },
  // {
  //   header: "Don't Have Enough Time?",
  //   text:
  //     "We get it. Starting at $99 / month, you can have a dedicated assistant that can help you with everything app related - from creating and managing the entire app and its features to helping design promotional materials. Send them a text with your request and consider it done!",
  //   bullets: [],
  // },
];
